/**
 * Thin wrapper around @capacitor/haptics. Each call is wrapped in a
 * silent try/catch so importing this module is safe from any context
 * (plain web, web preview, native iOS/Android). On unsupported
 * platforms the calls are simply no-ops.
 */
import { Capacitor } from '@capacitor/core';

const isNative = (() => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch (_) { return false; }
})();

let pluginPromise = null;
const getPlugin = () => {
  if (!isNative) return Promise.resolve(null);
  if (!pluginPromise) {
    pluginPromise = import('@capacitor/haptics').catch(() => null);
  }
  return pluginPromise;
};

export const hapticLight = async () => {
  try {
    const mod = await getPlugin();
    if (mod?.Haptics?.impact) await mod.Haptics.impact({ style: mod.ImpactStyle.Light });
  } catch (_) { /* noop */ }
};

export const hapticMedium = async () => {
  try {
    const mod = await getPlugin();
    if (mod?.Haptics?.impact) await mod.Haptics.impact({ style: mod.ImpactStyle.Medium });
  } catch (_) { /* noop */ }
};

export const hapticSuccess = async () => {
  try {
    const mod = await getPlugin();
    if (mod?.Haptics?.notification) await mod.Haptics.notification({ type: mod.NotificationType.Success });
  } catch (_) { /* noop */ }
};

export const hapticError = async () => {
  try {
    const mod = await getPlugin();
    if (mod?.Haptics?.notification) await mod.Haptics.notification({ type: mod.NotificationType.Error });
  } catch (_) { /* noop */ }
};
